import { render, staticRenderFns } from "./FormDentista.vue?vue&type=template&id=e145385a&"
import script from "./FormDentista.vue?vue&type=script&lang=js&"
export * from "./FormDentista.vue?vue&type=script&lang=js&"
import style0 from "./FormDentista.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports